import { Component, Input, OnChanges } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import {
  QaiLabelComponent,
  QaiResultsTabComponent,
  QaiSectionHeaderComponent,
  type SectionHeaderIndicator,
} from '@qai/ui';
import { ISkillDetail } from 'src/app/interfaces/iskill-detail';

type SkillScore = 'Expert' | 'Proficient' | 'Developing';

const BADGE_KIND: Record<SkillScore, 'green' | 'yellow' | 'red'> = {
  Expert: 'green',
  Proficient: 'yellow',
  Developing: 'red',
};

const SCORE_KEY: Record<SkillScore, string> = {
  Expert: 'EXPERT',
  Proficient: 'PROFICIENT',
  Developing: 'DEVELOPING',
};

interface SkillViewModel {
  title: string;
  scoreIndicator: SectionHeaderIndicator;
  feedback: string;
}

@Component({
  selector: 'app-result-skills',
  standalone: true,
  imports: [
    TranslocoModule,
    QaiResultsTabComponent,
    QaiSectionHeaderComponent,
    QaiLabelComponent,
  ],
  templateUrl: './result-skills.component.html',
  styleUrls: ['./result-skills.component.scss'],
})
export class ResultSkillsComponent implements OnChanges {
  @Input() skills: ISkillDetail[] = [];

  viewSkills: SkillViewModel[] = [];

  constructor(private readonly translocoService: TranslocoService) {}

  ngOnChanges(): void {
    this.viewSkills = this.skills.map((s) => ({
      title: s.title,
      scoreIndicator: {
        type: 'badge' as const,
        kind: BADGE_KIND[s.score],
        label: this.translocoService.translate(SCORE_KEY[s.score], {}, 'results'),
      },
      feedback: s.feedback,
    }));
  }
}
